import { SkeletonRows } from '../core/ui';

/** "This computer." before the shell has answered. Home draws it eagerly, while the section's own code loads. */
export function LocalFilesSkeleton() {
  return (
    <section aria-labelledby="mv-local-h" className="mv-home-panel mv-local-files">
      <div className="mv-home-list-head">
        <h2 id="mv-local-h" className="mv-home-h">
          This computer.
        </h2>
      </div>
      <SkeletonRows count={3} />
    </section>
  );
}
